import {LoadingPing} from '@autocut/components/LoadingPing/LoadingPing';
import {type PingConfig, pingConfigs} from '@autocut/configs/pings';
import {Text} from '@autocut/designSystem/components/atoms/Text/Text';
import {Tooltip} from '@autocut/designSystem/components/atoms/Tooltip/Tooltip';
import axios from 'axios';
import {useEffect, useState} from 'react';

export type Pings = Record<
  string,
  PingConfig & {
    status: 'loading' | 'success' | 'error' | 'warning';
    duration?: number;
  }
>;

export const Pings = () => {
  const [pings, setPings] = useState<Pings>({});

  useEffect(() => {
    const pings = {...pingConfigs} as Pings;

    Object.entries(pings).forEach(([key, value]) => {
      pings[key] = {
        ...value,
        status: 'loading',
      };
    });

    setPings(pings);

    const pingPromises = Object.entries(pings).map(([key, value]) => {
      const start = Date.now();
      console.log('pinging', value.url);
      return axios
        .get(value.url)
        .then(res => {
          console.log('pinging', value.url, res.status, value.expectedResponse);
          const duration = Date.now() - start;
          let status: Pings[typeof key]['status'] = 'loading';
          if (res.status === (value.expectedResponse?.status || 200)) {
            const bodyValid = value.expectedResponse?.bodyValidator?.(res.data);
            if (
              bodyValid ||
              value.expectedResponse?.bodyValidator === undefined
            ) {
              status = 'success';
            } else {
              status = 'warning';
            }
          } else {
            status = 'warning';
          }
          setPings(prev => ({
            ...prev,
            [key]: {
              ...prev[key],
              status,
              duration,
            },
          }));
        })
        .catch(err => {
          console.error(err);
          setPings(prev => ({
            ...prev,
            [key]: {
              ...prev[key],
              status: 'error',
              duration: Date.now() - start,
            },
          }));
        });
    });
  }, []);

  return (
    <div style={{marginLeft: 16}}>
      {Object.entries(pings).map(([key, ping]) => (
        <Tooltip
          tooltipPosition="right"
          tooltipComponent={
            <div>
              <Text variant="textSm.semibold">{ping.url}</Text>
            </div>
          }
        >
          <div
            key={ping.name}
            style={{display: 'flex', alignItems: 'center', gap: 4}}
          >
            <LoadingPing
              color={
                ping.status === 'success'
                  ? 'lime'
                  : ping.status === 'error'
                    ? 'red'
                    : 'white'
              }
            />
            <Text variant="textSm.semibold">
              {ping.name}{' '}
              {ping.duration ? ` (${ping.duration.toFixed(0)}ms)` : ''}
            </Text>
          </div>
        </Tooltip>
      ))}
    </div>
  );
};
